import script from "./ArchiveCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveCard.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveCard.vue?vue&type=style&index=0&id=01d07fba&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d07fba"]])

export default __exports__